import {
  OverlayComponentUserParams,
  SelectionColumnDef,
} from "ag-grid-community";

export const overlayComponentParams: OverlayComponentUserParams = {
  loading: { overlayText: "Loading contacts..." },
  noRows: { overlayText: "No contacts found" },
  noMatchingRows: {
    overlayText: "No contacts found",
  },
};

export const selectionColumnDef: SelectionColumnDef = {
  pinned: "left",
  width: 56,
  sortable: false,
  resizable: false,
  lockPosition: true,
};
